import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import {
    IMLSkill,
    ModalResultType,
} from '@models';
import {
    GRID_SERVICE,
    ODataGridComponent,
} from '@pages/generics/grid';
import {
    MLSkillsService,
    ModalService,
} from '@services';

import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject } from 'rxjs';

import {
    MLSkillsModalComponent,
    MLSkillVersionsModalComponent,
} from './modals';

@Component({
    templateUrl: './mlskills.page.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: MLSkillsService,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MLSkillsPageComponent extends ODataGridComponent<IMLSkill, string> {
    public loading = {
        mlskillsDetails$: new BehaviorSubject(false),
    };

    private _modalService = this._injector.get<ModalService>(ModalService);

    public openModal(model?: IMLSkill) {
        const clone = cloneDeep(model);

        this._modalService
            .openModal(MLSkillsModalComponent, clone)
            .afterClosedResult()
            .subscribe(res => {
                if (res.type === ModalResultType.Add) {
                    this._refresh$.next();
                }
            });
    }

    public showMLSkill(mlskill: IMLSkill) {
        this.loading.mlskillsDetails$.next(true);

        const clone = cloneDeep(mlskill);

        this.loading.mlskillsDetails$.next(false);

        this._modalService
            .openModal(MLSkillVersionsModalComponent, clone)
            .afterClosedResult()
            .subscribe(res => {
                if (res.type === ModalResultType.Update) {
                    this._refresh$.next();
                }
            });
    }
}
